import React, { useState, forwardRef, useEffect } from "react";
import SuccessAlertModal from "../Modals/successAlertModal";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Form, Button } from "react-bootstrap";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import dayjs from "dayjs";
import { getCurrentDateTime } from "../../functions/welding-functions";
import { GetDeviationReport, getDeviationCategories, getAllCapaByDev, getAllDeviaitons } from "../../Services/deviationcapa-service";
import { exportDeviationToExcel } from "../utility/data/export/ExcelUtils";
import { DateInput } from "../utility/common/helpers/DateComponent";
import { showWarning, showInfo } from "../utility/ui/notifications/Toaster";
import { createDropdown, refreshDropdown } from "../utility/common/DropdownComponent/DropdownHelper";

const DeviationReport = forwardRef((props, ref) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [projNumResult, setProjNumResult] = useState([]);
  const [devNumResult, setDevNumResult] = useState([]);
  const [welderResult, setWelderResult] = useState([]);
  const [observerCodeResult, setObserverCodeResult] = useState([]);
  const [deviationCategoryResult, setDeviationCategoryResult] = useState([]);
  const [supervisorCodeResult, setSupervisorCodeResult] = useState([]);
  const msg = "";
  const history = useNavigate();
  const handleCloseSuccess = () => setShowSuccess(false);
  const [deviationObj, setDeviationObj] = useState({});
  let todayDate = getCurrentDateTime("-");
  const [datevalue, setdatevalue] = useState(false);
  const [error, setError] = useState({});

  const fetchRaise = async () => {
    const result = await getAllDeviaitons();
    result?.sort(sortByPropertyInAscending("deviationNumber"));

    let tempDev = [];
    let tempProj = [];
    let tempWelder = [];
    let tempSupervisor = [];
    let tempObserver = [];
    for (let i = 0; i < result?.length; i++) {
      tempDev.push({ "Name": result[i].deviationNumber, "Code": result[i].deviationNumber })
      let chk = tempProj.filter(x => x.Name === result[i].projectNumber);
      if (chk?.length === 0 || tempProj?.length === 0) {
        tempProj.push({ "Name": result[i].projectNumber, "Code": result[i].projectNumber })
      }
      chk = tempWelder.filter(x => x.Code === result[i].welderCode);
      if (chk?.length === 0 || tempWelder?.length === 0) {
        tempWelder.push({ "Name": result[i].welderCode + " " + result[i].welderName, "Code": result[i].welderCode })
      }
      chk = tempSupervisor.filter(x => x.Code === result[i].supervisorCode);
      if (chk?.length === 0 || tempSupervisor?.length === 0) {
        tempSupervisor.push({ "Name": result[i].supervisorName + " (" + result[i].supervisorCode + ")", "Code": result[i].supervisorCode, "Dept": result[i].supervisorDept });
      }
      chk = tempObserver?.filter(x => x.Code === result[i].observerCode);
      if (chk?.length === 0 || tempObserver?.length === 0) {
        tempObserver.push({ "Name": result[i].observerName + " (" + result[i].observerCode + ")", "Code": result[i].observerCode, "Dept": result[i].observerDept })
      }
    }
    setProjNumResult(tempProj)
    setDevNumResult(tempDev);
    setWelderResult(tempWelder);
    setSupervisorCodeResult(tempSupervisor);
    setObserverCodeResult(tempObserver);
  };

  const resetForm = () => {
    setDeviationObj({});
  }

  const fetchDeviationCategory = async () => {
    let result = createDropdown("Deviation Category");
    await refreshDropdown("Deviation Category");
    let temp = result?.length > 0 ? result : [];
    setDeviationCategoryResult(temp);
  }

  function sortByPropertyInAscending(property) {
    return function (a, b) {
      if (a[property] > b[property]) return 1;
      else if (a[property] < b[property]) return -1;
      return 0;
    };
  }

  const handleChange = (e) => {
    if (e.target.name === "projectNumber") {
      e.target.value = ("" + e.target.value).toUpperCase();
    }
    const { name, value } = e.target;
    setDeviationObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchRaise();
    fetchDeviationCategory();
  }, []);

  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setDeviations",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (error.observationDateFrom?.status === true || error.observationDateTo?.status === true) {
      showWarning("Selected date cannot be greater than observation To date");
      return;
    }
    let temp = {};
    for (let key of Object.keys(deviationObj)) {

      if (deviationObj[key] !== null && deviationObj[key] !== undefined && deviationObj[key] !== "") {
        temp[key] = deviationObj[key];
      }
    }
    if (temp.supervisorCode?.length > 0) {
      let supernm = temp.supervisorCode?.split("(");
      let supercode = supernm[1]?.split(")");
      temp.supervisorCode = supercode[0].trim();
      temp.supervisorName = supernm[0].trim();
    }
    if (temp.observerCode?.length > 0) {
      let obsnm = temp.observerCode?.split("(");
      let obscode = obsnm[1]?.split(")");
      temp.observerCode = obscode[0].trim();
      temp.observerName = obsnm[0].trim();
    }
    let excelData = await GetDeviationReport(temp);
    let devNumbers = [];
    for (let item of excelData) {
      item.observationDate = dayjs(item.observationDate).format("DD/MM/YYYY");
      devNumbers.push(item.deviationNumber);
    }

    let capaData = await getAllCapaByDev(devNumbers);
    if (capaData?.length > 0) {
      for (let item of excelData) {
        let chk = capaData.filter(x => x.deviationNumber === item.deviationNumber);
        if (chk?.length > 0) {
          item.correctiveAction = chk[0].correctiveAction;
          item.actionTakenBy = chk[0].actionTakenBy;
          item.actionTakenDate = chk[0].actionTakenDate;
          item.actionTimeTaken = chk[0].actionTimeTaken;
          item.rootCauseAnalysis = chk[0].rootCauseAnalysis;
          item.preventiveAction = chk[0].preventiveAction;
          item.capaStatus = chk[0].capaStatus;
        }
      }
    }
    let filename = "Deviation Report";
    if (excelData?.length > 0) {
      exportDeviationToExcel(filename, excelData);
    }
    else {
      showInfo("There are no records matching to filters.");
    }
  };

  const handleDropDownChange = async (e) => {
    const { name, value } = e.target;
    if (name === "observerCode") {
      let roledesc1 = e.target.children[e.target.selectedIndex].getAttribute('result');
      setDeviationObj((prevState) => ({
        ...prevState,
        [name]: value,
        observerDept: roledesc1
      }));
      if (value === "") {
        setDeviationObj((prevState) => ({
          ...prevState,
          observerDept: ""
        }));
      }
    }
    if (name === "supervisorCode") {
      let roledesc1 = e.target.children[e.target.selectedIndex].getAttribute('result');
      setDeviationObj((prevState) => ({
        ...prevState,
        [name]: value,
        supervisorDept: roledesc1
      }));
      if (value === "") {
        setDeviationObj((prevState) => ({
          ...prevState,
          supervisorDept: ""
        }));
      }
    }
    else {
      setDeviationObj((prevState) => ({
        ...prevState,
        [name]: value
      }));
    }
  }

  return (
    <Container fluid className="main-container">
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={msg}
        show={showSuccess}
        handleClose={handleCloseSuccess}
      />
      <Row className="RowHeight mb-3">
        <Col md={3} xs={12} className="deviationheaderResp">
          Welding Deviation Report Filters
        </Col>
      </Row>
      <div className="mobile-scroll mt-3">
        <Form onSubmit={handleSubmit} onReset={resetForm} autoComplete="off">
          <div className="px-2 pb-2">
            <Row className="gx-2">
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <Form.Group className="g-select">
                  <div className="d-grid align-items-center">
                    <Form.Select
                      id="projectNumber"
                      name="projectNumber"
                      type="text"
                      placeholder=" "
                      value={deviationObj.projectNumber}
                      onChange={(e) => { handleDropDownChange(e) }}
                    >
                      <option value="">Select</option>
                      {projNumResult ? projNumResult.map((projNum) => (
                        <option key={projNum.Code} value={projNum.Name}>{projNum.Name}</option>
                      )) : null
                      }
                    </Form.Select>
                    <Form.Label htmlFor="projectNumber">Project Number</Form.Label>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <Form.Group className="g-select">
                  <div className="d-grid align-items-center">
                    <Form.Select
                      id="deviationNumber"
                      name="deviationNumber"
                      type="text"
                      placeholder=" "
                      value={deviationObj.deviationNumber}
                      onChange={(e) => { handleDropDownChange(e) }}
                    >
                      <option value="">Select</option>
                      {devNumResult ? devNumResult.map((devNum) => (
                        <option key={devNum.Code} value={devNum.Name}>{devNum.Name}</option>
                      )) : null
                      }
                    </Form.Select>
                    <Form.Label htmlFor="deviationNumber">Deviation Number</Form.Label>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <Form.Group className="g-select">
                  <div className="d-grid align-items-center">
                    <Form.Select
                      id="deviationCategory"
                      name="deviationCategory"
                      type="text"
                      placeholder=" "
                      value={deviationObj.deviationCategory}
                      onChange={(e) => { handleDropDownChange(e) }}
                    >
                      {deviationCategoryResult ? deviationCategoryResult.map((deviationCategoryResult) => (
                        <option key={deviationCategoryResult.name} value={deviationCategoryResult.value}>{deviationCategoryResult.name}</option>
                      )) : null
                      }
                    </Form.Select>
                    <Form.Label htmlFor="deviationCategory">Deviation Category</Form.Label>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }} >
                <Form.Group className="g-select">
                  <div className="d-grid align-items-center">
                    <Form.Select
                      id="welderCode"
                      name="welderCode"
                      type="text"
                      placeholder=" "
                      value={deviationObj.welderCode}
                      onChange={(e) => { handleDropDownChange(e) }}
                    >
                      <option value="">Select</option>
                      {welderResult ? welderResult.map((weldercd) => (
                        <option key={weldercd.Code} value={weldercd.Code}>{weldercd.Name}</option>
                      )) : null
                      }
                    </Form.Select>
                    <Form.Label htmlFor="welderCode">Welder Code</Form.Label>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <Form.Group className="g-select">
                  <div className="d-grid align-items-center">
                    <Form.Select
                      id="supervisorCode"
                      name="supervisorCode"
                      type="text"
                      placeholder=" "
                      value={deviationObj.supervisorCode}
                      onChange={(e) => { handleDropDownChange(e) }}
                    >
                      <option value="">Select</option>
                      {supervisorCodeResult ? supervisorCodeResult.map((supervisor) => (
                        <option key={supervisor.Code} result={supervisor.Dept} value={supervisor.Name}>{supervisor.Name}</option>
                      )) : null
                      }
                    </Form.Select>
                    <Form.Label htmlFor="supervisorCode">Supervisor Code</Form.Label>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <Form.Group className="g-input">
                  <div className="d-grid align-items-center">
                    <Form.Control
                      id="supervisorDept"
                      name="supervisorDept"
                      type="text"
                      readOnly
                      placeholder=" "
                      value={deviationObj.supervisorDept}
                    />
                    <Form.Label htmlFor="supervisorDept">Supervisor Department</Form.Label>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <DateInput
                  divClass="Date-input w-100"
                  label="Observation Date From"
                  className="groove_datecolor"
                  name="observationDateFrom"
                  todayDate={todayDate}
                  obj={deviationObj}
                  setobj={setDeviationObj}
                  datevalue={datevalue}
                  setdatevalue={setdatevalue}
                  todate={deviationObj.observationDateFrom}
                  setError={setError}
                />
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <DateInput
                  divClass="Date-input w-100"
                  label="Observation Date To"
                  className="groove_datecolor"
                  name="observationDateTo"
                  todayDate={todayDate}
                  obj={deviationObj}
                  setobj={setDeviationObj}
                  datevalue={datevalue}
                  setdatevalue={setdatevalue}
                  todate={deviationObj.observationDateTo}
                  setError={setError}
                />
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <Form.Group className="g-select">
                  <div className="d-grid align-items-center">
                    <Form.Select
                      id="observerCode"
                      name="observerCode"
                      type="text"
                      placeholder=" "
                      value={deviationObj.observerCode}
                      onChange={(e) => { handleDropDownChange(e) }}
                    >
                      <option value="">Select</option>
                      {observerCodeResult ? observerCodeResult.map((observerCodeResult) => (
                        <option key={observerCodeResult.Code} result={observerCodeResult.Dept} value={observerCodeResult.Name}>{observerCodeResult.Name}</option>
                      )) : null
                      }
                    </Form.Select>
                    <Form.Label htmlFor="observerCode">Observer Code</Form.Label>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <Form.Group className="g-input">
                  <div className="d-grid align-items-center">
                    <Form.Control
                      id="observerDept"
                      name="observerDept"
                      type="text"
                      readOnly
                      placeholder=" "
                      value={deviationObj.observerDept}
                    />
                    <Form.Label htmlFor="observerDept">
                      Observer Department
                    </Form.Label>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={3} md={3} xs={12} style={{ paddingBottom: "8px" }}>
                <Form.Group className="g-select">
                  <div className="d-grid align-items-center">
                    <Form.Select
                      id="devstatus"
                      name="devstatus"
                      type="text"
                      placeholder=" "
                      value={deviationObj.devstatus}
                      onChange={(e) => { handleChange(e) }}
                    >
                      <option key="select" value="">Select</option>
                      <option key="open" value="Open">Open</option>
                      <option key="closed" value="Closed">Closed</option>
                    </Form.Select>
                    <Form.Label htmlFor="status">Status</Form.Label>
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </div>
          <div className="px-2 pb-2">
            <Row>
              <Col>
                <Button variant="outline-success" type="reset" className="semiBoldToggleButton tempSaveBtn">
                  Reset
                </Button>
              </Col>
              <Col>
                <Button type="submit" className="btn-add-color semiBoldToggleButton rightAlignedButton" >
                  Submit
                </Button>
              </Col>
            </Row>
          </div>
        </Form>
      </div>

    </Container >
  );
});

export default DeviationReport;

